export const QUESTION_TYPES = [
  {
    key: 'free_text',
    value: 'FREE_TEXT',
  },
  {
    key: 'number_input',
    value: 'NUMBER_INPUT',
  },
  {
    key: 'combo_selection',
    value: 'COMBO_SELECTION',
  },
  {
    key: 'dropdown_list',
    value: 'DROPDOWN_LIST',
  },
  {
    key: 'number-rating',
    value: '1_TO_5_RATING',
  },
  {
    key: 'smiley_rating',
    value: 'SMILEY_RATING',
  },
  {
    key: 'star_rating',
    value: 'STAR_RATING',
  },
  {
    key: 'phone',
    value: 'PHONENUMBER',
  },
  {
    key: 'email',
    value: 'EMAIL',
  },
  {
    key: 'single_choice_markup',
    value: 'SINGLE_CHOICE_MARKUP',
  },
  {
    key: 'multiple_choice_markup',
    value: 'MULTIPLE_CHOICE_MARKUP',
  },
  {
    key: 'checkbox',
    value: 'CHECKBOX',
  },
];

export function getQuestionTypes() {
  return QUESTION_TYPES.map(x => {
    return {
      ...x,
      value: this.$t(`CSAT_MGMT.QUESTION_TYPES.${x.value}`),
    };
  });
}

export const DEFAULT_QUESTION_VALUES = {
  title: '',
  type: 'free_text',
  options: [],
  enabled: true,
  mandatory: false,
};
